import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Component, EventEmitter, HostListener, Output} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

import {CvsModel} from '../cvs/cvs.model';
import {UserService} from '../core/ecv-http-services/services/user.service';
import {CvsUtils} from '../cvs/cvs.utils';
import {FileSaverService} from '../shared/file-saver-service';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {SemanticEnrichmentService} from '../core/ecv-http-services/services/semantic-enrichment.service';
import {DialogWikipediaAnchorsComponent} from '../ecv-project/dialog/dialog.wikipedia-anchors/dialog.wikipedia-anchors.component';


@Component({
  selector: 'app-dialog-cv-preview',
  templateUrl: './dialog.cv-preview.component.html',
})
export class DialogCVPreviewComponent {
  cvs: CvsModel[] = [];
  currentIndex = 0;
  windowWidth: number;
  windowYOffset: number;
  cvsContentCache: SafeResourceUrl[] = [];
  @Output() closeEmitter = new EventEmitter();

  constructor(public activeModal: NgbActiveModal,
              private userService: UserService,
              private fileSaverService: FileSaverService,
              private spinnerService: Ng4LoadingSpinnerService,
              private semanticEnrichmentService: SemanticEnrichmentService,
              private modalService: NgbModal,
              private sanitizer: DomSanitizer) {
  }

  close() {
    this.activeModal.close(false);
  }

  dismiss(s: string) {
    this.activeModal.dismiss(s);
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    this.windowYOffset = window.pageYOffset;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize($event) {
    this.windowWidth = $event.target.innerWidth;
  }

  public downloadCV() {
    this.fileSaverService.saveCvFile(this.cvs[this.currentIndex].id);
  }

  public showWikipediaAnchors() {
    this.spinnerService.show();
    this.semanticEnrichmentService.getWikipediaAnchors(this.cvs[this.currentIndex].id).subscribe(
      (response) => {
        this.spinnerService.hide();
        const modalRef = this.modalService.open(DialogWikipediaAnchorsComponent);
        modalRef.componentInstance.model = response;
      },
      () => {
        this.spinnerService.hide();
      })
  }

  public scrollYPosition() {
    if (this.windowWidth < 992) {
      return 0;
    }
    return Math.max(this.windowYOffset - 200, 0);
  }

  public updateCurrentContent(index: number): void {
    if (this.cvsContentCache && this.cvsContentCache[index]) {
      return;
    }
    this.userService.getCvContent(this.cvs[index].id).subscribe(
      response => {
        this.cvs[index].content = response.toString();
        const sanitized = this.sanitizer.bypassSecurityTrustResourceUrl(CvsUtils.getFileURL(response.toString()));
        this.cvsContentCache[index] = sanitized;
      }
    );
  }

  public objectSupported(): boolean {
    return !(CvsUtils.detectBrowserSupportsPdfPreview() > 0);
  }

  ngOnDestroy() {
    this.closeEmitter.emit();
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/dialog/dialog.cv-preview.component.ts